import { render, staticRenderFns } from "./the-purchase-condition-confirm-dialog.vue?vue&type=template&id=182c0dc0"
import script from "./the-purchase-condition-confirm-dialog.vue?vue&type=script&lang=ts"
export * from "./the-purchase-condition-confirm-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports